import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { COURSE_TYPES_QUERY } from '../graphql/queries'
import { FETCH_COURSE_TYPES } from '../redux/action-types'
import { cleanupFetchCourseTypes } from '../redux/actions'

const useCourseTypesQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchCourseTypes)

  const { isLoading, error, initialData, latestEvent } = useSelector(
    store => store.courseTypes.courseTypes,
  )

  const refetch = useCallback(
    () =>
      apolloService.query(COURSE_TYPES_QUERY, {}, dispatch, FETCH_COURSE_TYPES),

    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, initialData, latestEvent }
}

export default useCourseTypesQuery
